module.exports = __webpack_public_path__ + "img/categories-4.bdaea5db.jpg";